// Street autocomplete component for vue. Depends on bootstrap-vue library.
require("custom-event-polyfill");

import Vue from "vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";
import VueSimpleSuggest from 'vue-simple-suggest'

// Internal
class Addr {
    address: string;
    streetAddress: string;
    postalCode: string;
    postOffice: string;
    locale: string;
    constructor(streetAddress: string, postalCode: string, postOffice: string, locale?: string) {
        this.streetAddress = streetAddress;
        this.postalCode = postalCode;
        this.postOffice = postOffice;
        this.address = streetAddress + ", " + postalCode + " " + postOffice;
        this.locale = locale;
    }
}

@Component({
    components: {
        VueSimpleSuggest
    }
})

export default class StreetAutocomplete extends Vue {
    @Prop({ required: true })
    value: string;

    @Prop({ default: false })
    showFullAddress: boolean;

    @Prop()
    locale: string;

    @Prop()
    zipLocale: string;

    @Prop({ default: false })
    disabled: boolean;

    get displayValueField() {
        return this.showFullAddress ? "address" : "streetAddress";
    }

    query = "";
    selectedItem: Addr = new Addr("", "", "");
    selectedLocale: string;

    autoCompleteStyle =  {
        vueSimpleSuggest: "position-relative",
        inputWrapper: "",
        defaultInput: "form-control",
        suggestions: "position-absolute list-group z-1000",
        suggestItem: "list-group-item"
    }

    @Prop({ default: "" })
    postalFilter: string;

    @Emit()
    streetSelected(_street: string, _locale: string) { 
    }

    @Emit()
    streetAddressSelected(_streetName: string, _postalCode: string, _postOffice: string,_locale: string) {
    }

    @Watch("value")
    keepValueSync(oldValue, newValue) {
        this.query = this.value;  
    }

    mounted() {
        this.query = this.value;
    }

    searchForStreets(query: string): Promise<Addr[]> {        
        return new Promise<Addr[]>((resolve, reject) => {
            if (query.length > 1) {
                const hub = $.connection.commonHub.server;
                const postalFilter = this.postalFilter || "";
                const locale = this.zipLocale;
                hub.searchStreetAddressFilter(query, postalFilter, locale).done(function (data) {
                    const arr: Addr[] = [];
                    for (let i = 0; i < data.length; ++i) {
                        const searchItem = data[i];
                        arr.push(new Addr(searchItem.Item1, searchItem.Item2, searchItem.Item3, searchItem.Item4));
                    }
                    resolve(arr);
                });
            }
            else {
                resolve([]);
            }
        });
    }

    onBlur() {
        // this makes sure that street is emitted even when no item is selected
        if (this.query == null || this.query == "") {
            this.selectedLocale = null;
        }
        this.streetSelected(this.query, this.selectedLocale);
    }

    itemSelected(selected: Addr) {
        console.log(selected);
        let streetAddress = "";
        let locale = selected ? selected.locale : null;
        this.selectedLocale = locale;
        if (!selected) {
            streetAddress = this.query;
            this.streetSelected(streetAddress, locale);
        }
        else {
            streetAddress = selected.streetAddress;

            // query is the string which user has typed so it might be something
            // like Kauppaka so we need to autocomplete it with the selected value to
            // make sure that onBlur doesn't emit wrong value
            this.query = selected.streetAddress

            // street address selected can only be triggered here when address is selected not just typed
            this.streetAddressSelected(selected.streetAddress, selected.postalCode, selected.postOffice, selected.locale);
        }
    }
}
